import { render, staticRenderFns } from "./CardGen.vue?vue&type=template&id=668c43e2&scoped=true"
import script from "./CardGen.vue?vue&type=script&lang=js"
export * from "./CardGen.vue?vue&type=script&lang=js"
import style0 from "./CardGen.vue?vue&type=style&index=0&id=668c43e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c43e2",
  null
  
)

export default component.exports